import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";
import {checkDocument} from "@js/helpers.ts";
import axios from "axios";
import {useCallbackStore} from "@js/store/CallbackStore.js";

const getProductFormDefaultData = () => ({
    product: null,
    bitrix_title: 'Быстрый заказ с сайта Вторчермет-1',
    data: {
        full_name: '',
        phone: '',
        captcha_token: '',
    },
    files: [],
    file_previews: [],
    isOpen: false,
    errors: [],
    animation_in_progress: false,
    sending: false,
    successfully_sent: false,
})

export const useProductStore = defineStore('productStore', {
    state: () => ({
        product: {
            price: null,
        },
        images: null,
        characteristics_grouped: null,
        callback: getProductFormDefaultData()
    }),

    actions: {
        sendPopupForm() {
            if (!checkDocument()) return;

            this.callback.errors = []
            this.callback.sending = false
            this.callback.data.captcha_token = ''
            this.callback.successfully_sent = false

            const captchaId = 'smart-captcha-container-fast-buy'
            const existingContainer = document.getElementById(captchaId)

            if (existingContainer) {
                try {
                    window.smartCaptcha.destroy(existingContainer.dataset.widgetId)
                } catch (e) {
                }
                existingContainer.remove()
            }

            const container = document.createElement('div')
            container.id = captchaId
            container.style.position = 'absolute'
            container.style.zIndex = '-1'
            document.body.appendChild(container)

            let tokenReceived = false

            const widgetId = window.smartCaptcha.render(captchaId, {
                sitekey: import.meta.env.VITE_YANDEX_SMARTCAPTCHA_SECRET,
                invisible: true,
                hideShield: true,
                callback: (token) => {
                    tokenReceived = true
                    this.callback.sending = true
                    this.callback.data.captcha_token = token

                    const formData = new FormData()
                    formData.append('bitrix_title', this.callback.bitrix_title || '')
                    formData.append('full_name', this.callback.data.full_name || '')
                    formData.append('phone', this.callback.data.phone || '')
                    formData.append('captcha_token', this.callback.data.captcha_token || '')
                    formData.append('comment', '')
                    formData.append('cart_products', JSON.stringify([this.callback.product]))

                    this.callback.files.forEach((file, index) => {
                        formData.append(`files[${index}]`, file)
                    })

                    axios.post('/axios/form/send-lead', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(() => {
                        this.callback.sending = false
                        this.callback.successfully_sent = true
                        this.callback.data.captcha_token = ''

                        try {
                            window.smartCaptcha.destroy(widgetId)
                        } catch (e) {
                        }
                    }).catch(error => {
                        this.callback.sending = false

                        if (error.response?.status === 422) {
                            this.callback.errors = error.response.data.errors
                        } else {
                            this.callback.errors = {
                                common: ['Не удалось отправить форму. Попробуйте ещё раз.']
                            }
                        }
                    })
                }
            })

            const captchaContainer = document.getElementById(captchaId)
            if (captchaContainer) {
                captchaContainer.dataset.widgetId = widgetId
            }

            window.smartCaptcha.subscribe(widgetId, 'challenge-hidden', () => {
                if (!tokenReceived) {
                    this.callback.sending = false
                    this.callback.errors = {
                        captcha_token: ['Вы закрыли капчу. Повторите попытку.']
                    }

                    try {
                        window.smartCaptcha.reset(widgetId)
                    } catch (e) {
                    }
                }
            })

            setTimeout(() => {
                try {
                    window.smartCaptcha.execute(widgetId)
                } catch (e) {
                    this.callback.sending = false
                    this.callback.errors = {
                        captcha_token: ['Не удалось запустить капчу. Попробуйте ещё раз.']
                    }
                }
            }, 100)
        },

        showFastBuyPopup(id) {
            axios.post('/axios/products/get-by-id', {
                id: id,
            }).then(response => {
                const previousProduct = this.callback.product
                this.callback = getProductFormDefaultData()
                this.callback.product = response.data ?? previousProduct

                const themeStore = useThemeStore()
                themeStore.setBodyOverflow(true)

                this.callback.animation_in_progress = false
                this.callback.isOpen = true
                this.callback.successfully_sent = false

                setTimeout(() => {
                    this.callback.animation_in_progress = true
                }, 50)
            })
        },

        closeFastBuyPopup() {
            const themeStore = useThemeStore()
            const callbackStore = useCallbackStore()

            themeStore.setBodyOverflow(false)
            this.callback.animation_in_progress = false

            setTimeout(() => {
                callbackStore.clearFormFilePreviews(this.callback)
                this.callback = getProductFormDefaultData()
            }, 300)
        },
    }
});
